export interface SchoolAgeGroupOption {
  value: string;
  label: string;
  /** Compact label for chips on village cards */
  shortLabel: string;
  /** Case-insensitive substrings matched against Fitness Village (service) names */
  villageKeywords: string[];
  /** Short, human readable list of villages this age group unlocks, for display */
  villagesHint: string;
}

export const SCHOOL_AGE_GROUP_OPTIONS: SchoolAgeGroupOption[] = [
  {
    value: '6-10 y/o',
    label: '6-10 Years Old',
    shortLabel: '6-10',
    villageKeywords: ['kite', 'warqa'],
    villagesHint: "Kite Beach, Al Warqa'a Park",
  },
  {
    value: '11-15 y/o',
    label: '11-15 Years Old',
    shortLabel: '11-15',
    villageKeywords: ['kite', 'warqa'],
    villagesHint: "Kite Beach, Al Warqa'a Park",
  },
  {
    value: '14 y/o +',
    label: '11-18 Years Old',
    shortLabel: '11-18',
    villageKeywords: ['zabeel'],
    villagesHint: 'Zabeel Park',
  },
];

export const isValidSchoolAgeGroup = (ageGroup?: string | null): boolean =>
  Boolean(ageGroup) &&
  SCHOOL_AGE_GROUP_OPTIONS.some(option => option.value === ageGroup);

export const getSchoolAgeGroupOption = (
  ageGroup?: string | null
): SchoolAgeGroupOption | undefined =>
  SCHOOL_AGE_GROUP_OPTIONS.find(option => option.value === ageGroup);

/**
 * Returns true when a village/service name matches the given age group's hardcoded
 * village mapping. When ageGroup is empty/unknown, everything matches so other
 * flows (or missing age group state) are unaffected.
 */
export const serviceMatchesAgeGroup = (serviceName?: string, ageGroup?: string | null): boolean => {
  if (!ageGroup) return true;
  const option = getSchoolAgeGroupOption(ageGroup);
  if (!option) return true;
  if (!serviceName) return false;
  const normalizedName = serviceName.toLowerCase();
  return option.villageKeywords.some(keyword => normalizedName.includes(keyword));
};
